/** @param {number} n */
export function round2(n) {
  return Math.round(n * 100) / 100
}
// this is all just a placeholder for now, we need to implement the actual math for the fees
/** Stripe-style ACH: 0.8% capped at $5 (on subtotal after platform fees). */
export function stripeAchFee(subtotal) {
  return Math.min(round2(subtotal * 0.008), 5)
}

/** Stripe card: 2.9% + $0.30 */
export function stripeCardFee(subtotal) {
  return round2(subtotal * 0.029 + 0.3)
}
